var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 693.07 660.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.61,660.89C149.81,660.89,0,512.94,0,330.45S149.81,0,334.61,0",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.07,660.89c-184.8,0-334.61-147.95-334.61-330.45S508.27,0,693.07,0",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrack);
export default __webpack_public_path__ + "static/media/IconTrack.8f5e441e9ab4cb24598279aa7c0bbab2.svg";
export { ForwardRef as ReactComponent };